module.exports = __webpack_public_path__ + "static/media/bannersports.0da533cd.jpeg";